// Booking filter persistence utility

// localStorage keys for booking filters
export const BOOKING_STORAGE_KEYS = {
  SAVED_FILTER: 'bookings_savedFilter',
  SIGNEE_FILTER: 'bookings_signeeFilter',
  DISPLAY_PRESET: 'bookings_displayPreset',
  SHOW_FILTERS: 'bookings_showFilters',
  SHOW_ADVANCE_FILTER: 'bookings_showAdvanceFilter',
  SEARCH_QUERY: 'bookings_searchQuery',
  SELECTED_DATE_RANGE: 'bookings_selectedDateRange',
  VIEW: 'bookings_view',
  IS_EQUIPMENT_VIEW: 'bookings_isEquipmentView',
  LIST_GROUP_BY_VIEW: 'bookings_listGroupByView',
  TIMELINE_GROUP_BY_VIEW: "booking_timelineGroupByView"
};

export const GROUP_BOOKING_STORAGE_KEYS = {
  SAVED_FILTER: 'bookings_group_savedFilter',
  SIGNEE_FILTER: 'bookings_group_signeeFilter',
  DISPLAY_PRESET: 'bookings_group_displayPreset',
  SHOW_FILTERS: 'bookings_group_showFilters',
  SHOW_ADVANCE_FILTER: 'bookings_group_showAdvanceFilter',
  SEARCH_QUERY: 'bookings_group_searchQuery',
  SELECTED_DATE_RANGE: 'bookings_group_selectedDateRange',
  VIEW: 'bookings_group_view',
  IS_EQUIPMENT_VIEW: 'bookings_group_isEquipmentView',
  LIST_GROUP_BY_VIEW: 'bookings_group_listGroupByView'
};

// Get a filter value from localStorage
export const getPersistedFilter = (key, defaultValue = null) => {
  try {
    const saved = localStorage.getItem(key);
    if (saved === null) return defaultValue;

    // Try to parse as JSON first
    try {
      return JSON.parse(saved);
    } catch {
      // If parsing fails, return as string
      return saved;
    }
  } catch (error) {
    console.warn(`Failed to get persisted filter for key: ${key}`, error);
    return defaultValue;
  }
};

// Set a filter value in localStorage
export const setPersistedFilter = (key, value) => {
  try {
    const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value;
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.warn(`Failed to persist filter for key: ${key}`, error);
  }
};

// Clear all booking filter preferences
export const clearAllBookingFilterPreferences = () => {
  Object.values(BOOKING_STORAGE_KEYS).forEach(key => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Failed to remove filter for key: ${key}`, error);
    }
  });
};

// Get all persisted booking filters
export const getAllPersistedBookingFilters = () => {
  const filters = {};
  Object.entries(BOOKING_STORAGE_KEYS).forEach(([name, key]) => {
    filters[name] = getPersistedFilter(key);
  });
  return filters;
};
